import { Injectable } from '@angular/core';
import { BaseService } from '../../../../shared/services/base.service';
import {
  ConsultationType,
  ConsultationValue,
  ConsultationStep
} from '../../../../models/consultation/consultation.model';
import { GroupWaitingModel } from '../../../../models/waiting-room/group-waiting.model';
import { IndividualWaitingModel } from '../../../../models/waiting-room/individual-waiting.model';
import 'rxjs/add/observable/of';
import { ConsultationUrl } from '../../../../shared/urls/consultation.url';
import { GroupTemplateUrl } from '../../../../shared/urls/group-template.url';
import { Utility } from '../../../../common/utility';
import { CentreUrl } from '../../../../shared/urls/centre.url';

@Injectable()
export class GroupTemplateService {
  constructor(public baseService: BaseService) { }

  getCentre() {
    const url = GroupTemplateUrl.GET_CENTRE;
    return this.baseService.getData(url);
  }
  createGroupTemplate(formData: FormData) {
    const url = GroupTemplateUrl.GROUP_TEMPLATE_ADD;
    return this.baseService.upload(url, formData);
  }

  updateGroupTemplate(id, formData: FormData) {
    const url = Utility.stringFormat(GroupTemplateUrl.GROUP_TEMPLATE_UPDATE, [id]);
    return this.baseService.upload(url, formData);
  }

  removeGroupTemplate(id) {
    const url = Utility.stringFormat(GroupTemplateUrl.GROUP_TEMPLATE_REMOVE, [id]);
    return this.baseService.delete(url);
  }

  getGroupTemplateList(param) {
    const url = GroupTemplateUrl.GROUP_TEMPLATE;
    return this.baseService.getData(url, param);
  }

  getGroupTemplateDetail(groupId) {
    let url = ConsultationUrl.GET_GROUP_CONSULTATION.replace('{id}', groupId);
    return this.baseService.getData(url);
  }

  addPatientToGroupTemplate(groupId, patientId) {
    const url = Utility.stringFormat(ConsultationUrl.ADD_PATIENT_TO_GROUP, [groupId]);
    return this.baseService.update(url, patientId);
  }

  removePatientFromGroupTemplate(groupId, patientId) {
    const url = ConsultationUrl.REMOVE_PATIENT_FROM_GROUP.replace('{patientId}', patientId)
      .replace('{groupId}', groupId);
    return this.baseService.delete(url);
  }

  getListCountry() {
    const url = GroupTemplateUrl.GET_DOWN_LIST_COUNTRY;
    return this.baseService.getAll(url);
  }

  getPatientAddList() {
    let url = ConsultationUrl.GET_LIST_PATIENT_ADDTOGROUP;
    return this.baseService.getData(url);
  }

  getDataPaymentTerm() {
    const url = ConsultationUrl.GET_PAYMENT_TERM;
    return this.baseService.getData(url);
  }

  getGroupMemberList(groupId, param) {
    let url = ConsultationUrl.GET_GROUP_CONSULTATION_MEMBER_LIST.replace('{id}', groupId);
    return this.baseService.getData(url, param);
    //   return this.baseService.getData(url, param);
    // return data;
  }
  /**
   * Add patient to patient table and remove this patient from patientArr
   *  @param addedPatientArr list table
   *  @param patientArr list add Patient
   */

  addPatientToTable(tableArr, patientArr) {
    for (let i = 0; i < tableArr.length; i++) {
      for (let j = 0; j < patientArr.length; j++) {
        if (tableArr[i].userId === patientArr[j].userId) {
          patientArr.splice(j, 1);
          j--;
        }
      }
    }
  }

  /**
   * Remove patient from patient table and add this patient back to patient list
   *  @param tableArr patient table
   *  @param patientArr list available Patient
   *  @param userId
   */

  removePatientFromTable(tableArr, patientArr, id) {
    for (let i = 0; i < tableArr.length; i++) {
      if (tableArr[i].userId === id) {
        patientArr.push(tableArr[i]);
        tableArr.splice(i, 1);
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template.service.ts